import React from 'react';

import styles from './style.css';

export default function alertIcon() {
  return (
    <div className={`sweet-alert ${styles.alertIcon}`} style={{ display: 'block' }}>
      <div className="sa-icon sa-success animate" style={{ display: 'block' }}>
        <span className="sa-line sa-tip animateSuccessTip" />
        <span className="sa-line sa-long animateSuccessLong" />
        <div className="sa-placeholder" />
        <div className="sa-fix" />
      </div>
    </div>
  );
}
